// The welcome screen (signed out). The first screen offers the three ways in: an invite link from
// a partner's email, sign-in with email, and recovery with a code. Sign-up with the sign-up code
// (SIGNUP_CODE) is behind a small link, and its field says it is not a partner link code. An
// opened invite link shows its own short form (name prefilled, the email it was sent to, no code).

export type WelcomeMode = 'start' | 'invite-help' | 'code' | 'signin' | 'recover' | 'invite';

/** What an opened invite link shows before sign-up: who invited, and the name they typed. */
export interface InviteInfo {
  inviterName: string;
  name: string | null;
}

const back = '<button class="reset" data-a="welcome-mode" data-mode="start">Back</button>';

export function vWelcome(mode: WelcomeMode = 'start', emailSignIn = true, invite: InviteInfo | null = null, email = ''): string {
  const attr = (v: string) => v.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  let form: string;
  switch (mode) {
    case 'invite':
      form = invite
        ? `<p class="hint"><b>${attr(invite.inviterName)}</b> invited you. Sign up to get your own budget, linked with theirs. You each keep your own budget; neither of you sees the other's purchases.</p>
  <label class="fld"><span>Your first name</span><input id="w-name" type="text" autocomplete="given-name" maxlength="60" value="${attr(invite.name ?? '')}" placeholder="Sam"></label>
  <label class="fld"><span>Your email</span><input id="w-email" type="email" autocomplete="email" placeholder="you@example.com" value="${attr(email)}"></label>
  <p class="hint">Use the email address the invite was sent to.</p>
  <p class="err" id="w-err"></p>
  <button class="btn primary" data-a="invite-signup">Join and link</button>
  ${back}`
        : `<p class="err" id="w-err">This invite link does not work. Ask for a new invite.</p>${back}`;
      break;
    case 'invite-help':
      form = `<p class="hint">Open the invite link from your email on this phone. It signs you up and links you with the person who invited you. No code needed.</p>
  <p class="hint">No email yet? Ask them to send the invite from Settings, Partner.</p>
  ${back}`;
      break;
    case 'code':
      form = `<label class="fld"><span>Your name</span><input id="w-name" type="text" autocomplete="given-name" maxlength="60" placeholder="Sam"></label>
  <label class="fld"><span>Sign-up code</span><input id="w-code" type="text" autocomplete="off" spellcheck="false"></label>
  <p class="hint">This is not a partner link code.</p>
  <p class="err" id="w-err"></p>
  <button class="btn primary" data-a="signup">Start my budget</button>
  ${back}`;
      break;
    case 'recover':
      form = `<label class="fld"><span>Your recovery code</span><input id="w-rcode" type="text" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="XXXX-XXXX-XXXX-XXXX"></label>
  <p class="err" id="w-err"></p>
  <button class="btn primary" data-a="recover">Recover my budget</button>
  ${back}`;
      break;
    case 'signin':
      form = `<label class="fld"><span>Your sign-in email</span><input id="w-email" type="email" autocomplete="email" placeholder="you@example.com" value="${attr(email)}"></label>
  <p class="err" id="w-err"></p>
  <button class="btn primary" data-a="magic-link">Email me a sign-in link</button>
  ${back}`;
      break;
    default:
      form = `<div class="welcomeways">
  <button class="btn primary" data-a="welcome-mode" data-mode="invite-help">I have an invite link</button>
  ${emailSignIn ? '<button class="btn" data-a="welcome-mode" data-mode="signin">Sign in with email</button>' : ''}
  <button class="btn" data-a="welcome-mode" data-mode="recover">Lost access? Recover with code</button>
  </div>
  <button class="reset" data-a="welcome-mode" data-mode="code">I have a sign-up code</button>`;
  }
  return `<section class="welcome">
  <h1>Hush</h1>
  <p class="lede">A budget that runs itself. Set it once, forward your card alerts, and only hear from it when something needs a decision.</p>
  ${form}
  <ul>
    <li>No bank logins, ever.</li>
    <li>No access to your inbox. You forward only the alerts you choose.</li>
    <li>You get your own private forwarding address.</li>
  </ul>
</section>`;
}
